import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { TiendaComponent } from './pages/tienda/tienda.component';
import { ZonasComponent } from './pages/zonas/zonas.component';
import { ProductoComponent } from './pages/producto/producto.component';
import { CarritoComponent } from './pages/carrito/carrito.component';
import { FinalizarComponent } from './pages/finalizar/finalizar.component';
import { LoginComponent } from './pages/espacio-mayoristas/login/login.component';
import { AuthGuardGuard } from './auth/guards/auth-guard.guard';
import { RegistroComponent } from './pages/espacio-mayoristas/registro/registro.component';
import { PoliticasPrivacidadComponent } from './pages/politicas-privacidad/politicas-privacidad.component';
import { TerminosCondicionesComponent } from './pages/terminos-condiciones/terminos-condiciones.component';
import { QuienesSomosComponent } from './pages/quienes-somos/quienes-somos.component';
import { ContactanosComponent } from './pages/contactanos/contactanos.component';
import { MetodosPagoComponent } from './pages/metodos-pago/metodos-pago.component';
import { CancelacionesDevolucionesComponent } from './pages/cancelaciones-devoluciones/cancelaciones-devoluciones.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'tienda/:cat/:tipo/:sub/:page', component: TiendaComponent },
  { path: 'zonas', component: ZonasComponent },
  { path: 'producto/:id', component: ProductoComponent },
  { path: 'login', component: LoginComponent },
  { path: 'registro', component: RegistroComponent },
  { path: 'finalizar', component: FinalizarComponent },
  {
    path: 'espacio-mayorista',
    loadChildren: () =>
      import('./pages/espacio-mayoristas/espacio-mayorista.module').then(
        (m) => m.EspacioMayoristaModule
      ),
    canActivate: [AuthGuardGuard],
  },
  { path: 'carrito', component: CarritoComponent },
  { path: 'politicas-de-privacidad', component: PoliticasPrivacidadComponent },
  { path: 'terminos-y-condiciones', component: TerminosCondicionesComponent },
  { path: 'quienes-somos', component: QuienesSomosComponent },
  { path: 'contactanos', component: ContactanosComponent },
  { path: 'metodos-de-pago', component: MetodosPagoComponent },
  {
    path: 'cancelaciones-y-devoluciones',
    component: CancelacionesDevolucionesComponent,
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
